var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"code"},[_vm._v("404")]),_c('P',[_vm._v("Resource Not Found")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }